import { createComponents } from './create-components';
import { createPalette } from './create-palette';
import { createShadows } from './create-shadows';

export const createOptions = ({ colorPreset, contrast,primaryBrandColor,primaryTextColor,secondaryBrandColor,secondaryTextColor }) => {
  const palette = createPalette({ colorPreset, contrast,primaryBrandColor,primaryTextColor,secondaryBrandColor,secondaryTextColor });
  const components = createComponents({ palette });
  const shadows = createShadows();

  return {
    components,
    palette,
    shadows
  };
};
